import React from 'react';
import { Card } from 'antd';

export default () => (
  <div className='padding'><Card loading/></div>
);